import axios from "axios";
import accessToken from "./jwt-token-access/accessToken";
import { error } from "toastr";
import { detail_data } from "common/data/detail_dashboard";

//pass new generated access token here
const token = accessToken;

//apply base url for axios
const API_URL = "https://remotedrishtee.com/api/";

const errorCode = [1, 2];

const axiosApi = axios.create({
  baseURL: API_URL,
  transformResponse: [(data) => {
    if (typeof data !== 'string') return data;
    try {
      return JSON.parse(data);
    } catch (e) {
      // API may return PHP debug output before JSON (e.g. "Array\n(\n)\n{...}")
      // Try to extract the JSON portion from the response
      const jsonStart = data.indexOf('{');
      if (jsonStart > 0) {
        try {
          return JSON.parse(data.substring(jsonStart));
        } catch (e2) {
          // fall through
        }
      }
      return data;
    }
  }],
});

// axiosApi.defaults.headers.common["Authorization"] = token;

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then((response) => {
      if (errorCode.includes(response.data?.error?.code)) {
        if (response.data?.error?.code === 1) {
          if (!response.config?.url?.includes('H264Playback2.php')) {
            Logout(response.data?.error?.msg);
          }
        }

        AlertError(response.data?.error?.msg);
      }
      return response.data;
    })
    .catch(error => {
      if (error?.response?.data?.error?.msg) {
        // Logout(error.response.data.msg);
        AlertError(error?.response?.data?.error?.msg);
        console.log("Error in get call ", error);
      }
      throw error;
    });
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}

function Logout(error) {
  window.localStorage.clear();
  window.location.replace('/login');
}

function AlertError(error) {
  // window.alert(error);
  console.log("Api Error Response", error);
}